import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_outbound_orders_grid_ComponentContextService } from './FootprintManager.outbound_orders_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { SalesOrders_sales_order_date_types_dd_singleComponent } from './SalesOrders.sales_order_date_types_dd_single.component'


interface IFootprintManager_outbound_orders_gridComponentEntity {
  Id?: number, CancelThresholdDate?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, FulfillmentDate?: string, LookupCode?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, PreferredCarrierId?: number, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, VendorReference?: string, Status?: { Id?: number, Name?: string }, OrderClass?: { LookupCode?: string }, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } }, PreferredWarehouse?: { Id?: number, Name?: string }, PreferredCarrier?: { Id?: number, Name?: string }, PreferredCarrierServiceType?: { Id?: number, Name?: string }, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number, Shipment?: { Cartonized?: boolean, ContainerSize?: string, ExpectedDate?: string, ExpectedWarehouseId?: number, LookupCode?: string, PickupDate?: string, ShippedDate?: string, StatusId?: number, TrackingIdentifier?: string, WaveId?: number, Wave?: { Description?: string, StatusId?: number, Status?: { Name?: string } }, Carrier?: { Id?: number, Name?: string }, CarrierServiceType?: { Id?: number, Name?: string }, ExpectedWarehouse?: { Name?: string } } }[], Account?: { Id?: number, AccountsContactsLookup?: { ContactId?: number, Contact?: { FirstName?: string, LastName?: string, PrimaryEmail?: string, PrimaryTelephone?: string, Address?: { AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] }, Addresses?: { AttentionOf?: string, City?: string, Country?: string, FirstName?: string, LastName?: string, Line1?: string, Line2?: string, PostalCode?: string, PrimaryEmail?: string, PrimaryTelephone?: string }[]}

interface IFootprintManager_outbound_orders_gridComponentInParams {
  ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], countries?: string[], carrierId?: number, carrierServiceId?: number, reference?: string, materialIds?: number[], waveId?: number}


class FootprintManager_outbound_orders_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_outbound_orders_gridComponent;
  entity: IFootprintManager_outbound_orders_gridComponentEntity;

  vars: { stateId?: number, dockAppointmentId?: number } = { };

  options: { on_row_edit_order: ButtonModel } = {
    on_row_edit_order: new ButtonModel('on_row_edit_order', new ButtonStyles(null, null), false, false, false, 'Edit order', '', null)

  }

 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    cartonized_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    orderclass: null,
    lookupcode: null,
    status: null,
    state: null,
    wave_id: null,
    project: null,
    reference: null,
    vendor_reference: null,
    total_items: null,
    appointment: null,
    warehouse: null,
    carrier: null,
    tracking: null,
    cartonized: null,
    created_date: null,
    created_by: null,
    requested_delivery_date: null,
    cancel_threshold_date: null,
    shipped_date: null,
    pickup_date: null,
    ship_to: null,
    delivery_country: null,
    notes: null,
  }



  constructor(
    grid: FootprintManager_outbound_orders_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_outbound_orders_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.orderclass = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.orderclass,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lookupcode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.state = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.state,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.wave_id = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.wave_id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.reference = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.reference,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.vendor_reference = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.vendor_reference,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.total_items = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.total_items,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.appointment = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.appointment,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.carrier = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.carrier,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.tracking = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.tracking,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.cartonized = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.cartonized,
      new CheckBoxModel(this.formGroup.controls['cartonized_display'] as DatexFormControl, null, true, false, '', null)
,
null
      );
    
    this.cells.created_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_by = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_by,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.requested_delivery_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.requested_delivery_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.cancel_threshold_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.cancel_threshold_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.shipped_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shipped_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.pickup_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.pickup_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ship_to = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ship_to,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.delivery_country = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.delivery_country,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_outbound_orders_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_outbound_orders_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      fromDate:  $grid.filters.date_from.control.value ,
      toDate:  $grid.filters.date_to.control.value ,
      countries:  $grid.inParams.countries ,
      carrierId:  $grid.inParams.carrierId ,
      carrierServiceId:  $grid.inParams.carrierServiceId ,
      reference:  $grid.inParams.reference ,
      take:  null ,
      skip:  null ,
      materialIds:  $grid.inParams.materialIds ,
      dateType:  $grid.filters.date_type.control.value ,
      waveId:  $grid.inParams.waveId ,
      orderIds:  null ,
      ship_to_search:  null ,
    };
    const data = await this.$datasources.SalesOrders.ds_outbound_orders_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_outbound_orders_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.orderclass.displayControl as TextModel).text = $row.entity.OrderClass?.LookupCode;
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.wave_id.displayControl as TextModel).text = ($row.entity.ShipmentOrderLookups[0]?.Shipment?.WaveId ?? '').toString();
    (this.cells.reference.displayControl as TextModel).text = $row.entity.OwnerReference;
    (this.cells.vendor_reference.displayControl as TextModel).text = $row.entity.VendorReference;
    (this.cells.tracking.displayControl as TextModel).text = $row.entity.ShipmentOrderLookups[0]?.Shipment?.TrackingIdentifier;
    (this.cells.cartonized.displayControl as CheckBoxModel).reset($row.entity.ShipmentOrderLookups.length > 0 && $row.entity.ShipmentOrderLookups.every(sol => sol.Shipment.Cartonized));
    (this.cells.created_by.displayControl as TextModel).text = $row.entity.CreatedSysUser;
    (this.cells.notes.displayControl as TextModel).text = $row.entity.Notes;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'lookupcode' : {
        this.on_lookupcode_clicked();
        break;
      }
      case 'wave_id' : {
        this.on_wave_clicked();
        break;
      }
      case 'appointment' : {
        this.on_appointment_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_lookupcode_clicked(event = null) {
    return this.on_lookupcode_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookupcode_clickedInternal(
    $row: FootprintManager_outbound_orders_gridComponentRowModel,
  $grid: FootprintManager_outbound_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  // Check order class type
  const order = (await $datasources.SalesOrders.ds_get_order_by_orderId.get({ orderId: $row.entity.Id })).result;
  if ($utils.isDefined(order)) {
      const orderClassTypeId = order.OrderClass.OrderClassTypeId;
      if (orderClassTypeId == 5) {
          $shell.FootprintManager.opensales_order_editor({ orderId: $row.entity.Id });
      }
      else {
          throw new Error('Editor for selected order class type under development!')
      }
  
  }
  
  
  
  
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_outbound_orders_gridComponentRowModel,
  $grid: FootprintManager_outbound_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Set Date/Time Formats
  const format = `${$settings.DockAppointments.DateFormat}, ${$settings.DockAppointments.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  // Apply date format
  if ($utils.isDefined($row.entity.CreatedSysDateTime)) {
      $row.cells.created_date.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime, format);
  };
  
  if ($utils.isDefined($row.entity.RequestedDeliveryDate)) {
      $row.cells.requested_delivery_date.displayControl.text = $utils.date.format($row.entity.RequestedDeliveryDate, format);
  };
  
  if ($utils.isDefined($row.entity.ShipmentOrderLookups[0]?.Shipment?.ShippedDate)) {
      $row.cells.shipped_date.displayControl.text = $utils.date.format($row.entity.ShipmentOrderLookups[0]?.Shipment?.ShippedDate, format);
  };
  
  if ($utils.isDefined($row.entity.CancelThresholdDate)) {
      $row.cells.cancel_threshold_date.displayControl.text = $utils.date.format($row.entity.CancelThresholdDate, format);
  };
  
  if ($utils.isDefined($row.entity.ShipmentOrderLookups[0]?.Shipment?.PickupDate)) {
      $row.cells.pickup_date.displayControl.text = $utils.date.format($row.entity.ShipmentOrderLookups[0].Shipment.PickupDate, format);
  };
  
  
  let shipment_carrier: string;
  let shipment_service: string;
  let shipment_warehouse: string;
  let ShipmentOrderLookups = $row.entity.ShipmentOrderLookups;
  
  if ($utils.isDefined(ShipmentOrderLookups)) {
      let Shipment = ShipmentOrderLookups[0].Shipment;
      shipment_carrier = Shipment.Carrier?.Name;
      shipment_service = Shipment.CarrierServiceType?.Name;
      shipment_warehouse = Shipment.ExpectedWarehouse?.Name;
  }
  
  //Set Carrier cell display control text
  var carrier = $utils.isDefined(shipment_carrier) ? shipment_carrier : 
                $utils.isDefined($row.entity.PreferredCarrier?.Name) ? $row.entity.PreferredCarrier?.Name : '';
  var service = $utils.isDefined(shipment_service) ? shipment_service : 
                $utils.isDefined($row.entity.PreferredCarrierServiceType?.Name) ? $row.entity.PreferredCarrierServiceType?.Name : '';
  var warehouse = $utils.isDefined(shipment_warehouse) ? shipment_warehouse :
                $utils.isDefined($row.entity.PreferredWarehouse?.Name) ? $row.entity.PreferredWarehouse?.Name : '';
  
  var carrierDetails = carrier.trim() + ' ' + service.trim();
  $row.cells.carrier.displayControl.text = carrierDetails;
  
  $row.cells.warehouse.displayControl.text = warehouse.trim();
  
  // Apply custom project string logic
  if ($row.entity.Project?.LookupCode === $row.entity.Project?.Name) {
      $row.cells.project.displayControl.text = $row.entity.Project.LookupCode
  } else {
      $row.cells.project.displayControl.text = $row.entity.Project.LookupCode + ' ' + $row.entity.Project.Name
  };
  
  
  }
  on_appointment_clicked(event = null) {
    return this.on_appointment_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_appointment_clickedInternal(
    $row: FootprintManager_outbound_orders_gridComponentRowModel,
  $grid: FootprintManager_outbound_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 08/17/2023
  
  let dock_appointment_id = $row.vars.dockAppointmentId;
  
  if ($utils.isDefined(dock_appointment_id)) {
  
      if ($utils.isDefined($row.entity.PreferredWarehouseId) || $utils.isDefined($row.entity.ShipmentOrderLookups[0]?.Shipment?.ExpectedWarehouseId)) {
          const dialogResult = await $shell.FootprintManager.opendock_appointment_editorDialog({
              dockAppointmentId: dock_appointment_id
          },'flyout',EModalSize.Large);
          if ($utils.isDefined(dialogResult)) {
              const userConfirm = dialogResult.confirm;
              if (userConfirm) {
                  $grid.refresh();
              }
          }
  
      }
      else {
          throw new Error('Unable to determined preferred warehouse from the selected order.')
     }
  
  }
  else {
        // Check if the selected order is in a rejected status and throw an error.
      if ($row.entity.OrderStatusId == 4096) {
  
          throw new Error('Selected order is currently in a rejected status, a dock appointment cannot be created against rejected orders.')
      }
  
      if ($utils.isDefined($row.entity.PreferredWarehouseId) || $utils.isDefined($row.entity.ShipmentOrderLookups[0]?.Shipment?.ExpectedWarehouseId)) {
          const nextAppointmentId = (await $flows.Utilities.reserve_nextId_flow({ entity: 'DockAppointment' })).nextId;
  
          const dialogResult = await $shell.FootprintManager.opendock_appointment_creation_formDialog({
  
              warehouseId: [$row.entity.PreferredWarehouseId] ?? [$row.entity.ShipmentOrderLookups[0]?.Shipment?.ExpectedWarehouseId],
              lookupcode: nextAppointmentId.toString(),
              scheduledArrival: $utils.isDefined($row.entity.RequestedDeliveryDate) ? $row.entity.RequestedDeliveryDate : $utils.date.now(),
              scheduledDeparture: $utils.isDefined($row.entity.RequestedDeliveryDate) ? $utils.date.add(1, 'hour', $row.entity.RequestedDeliveryDate) : $utils.date.add(1, 'hour', $utils.date.now()),
              typeId: 2,
              ownerId: $row.entity.Project.OwnerId,
              projectId: $row.entity.ProjectId,
              carrierId: $row.entity.PreferredCarrierId,
              orderId: $row.entity.Id
          },'flyout',EModalSize.Large );
  
          if ($utils.isDefined(dialogResult)) {
              const userConfirm = dialogResult.confirm;
              if (userConfirm) {
                  $grid.refresh();
              }
          }
      }
  
      else {
          throw new Error('Unable to determined preferred warehouse from the selected order.')
      }
  
  };
  }
  on_wave_clicked(event = null) {
    return this.on_wave_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_wave_clickedInternal(
    $row: FootprintManager_outbound_orders_gridComponentRowModel,
  $grid: FootprintManager_outbound_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let waveid = parseInt($row.cells.wave_id.displayControl.text)
  
  if (!isNaN(waveid)) { 
      $shell.FootprintManager.opensingle_wave_hub({
          waveId: waveid,
          waveDescription: $row.entity.ShipmentOrderLookups[0]?.Shipment?.Wave?.Description,
          waveStatus: $row.entity.ShipmentOrderLookups[0]?.Shipment?.Wave?.Status?.Name
      })
  }
  }
  on_row_edit_order(event = null) {
    return this.on_row_edit_orderInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_edit_orderInternal(
    $row: FootprintManager_outbound_orders_gridComponentRowModel,
  $grid: FootprintManager_outbound_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  // Check order class type
  const order = (await $datasources.SalesOrders.ds_get_order_by_orderId.get({ orderId: $row.entity.Id })).result;
  if ($utils.isDefined(order)) {
      const orderClassTypeId = order.OrderClass.OrderClassTypeId;
      if (orderClassTypeId == 5) {
          $shell.FootprintManager.opensales_order_editor({ orderId: $row.entity.Id });
      }
      else {
          throw new Error('Editor for selected order class type under development!')
      }
  
  }
  
  
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => SalesOrders_sales_order_date_types_dd_singleComponent),
  ],
  selector: 'FootprintManager-outbound_orders_grid',
  templateUrl: './FootprintManager.outbound_orders_grid.component.html'
})
export class FootprintManager_outbound_orders_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_outbound_orders_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_outbound_orders_gridComponentInParams = { ownerId: null, projectId: null, warehouseId: [], statusIds: [], countries: [], carrierId: null, carrierServiceId: null, reference: null, materialIds: [], waveId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     orderclass: new GridHeaderModel(new HeaderStyles(null, null), 'orderclass', 'Order class', false, false, null, false),       lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'lookupcode', 'Order', false, false, null, false),       status: new GridHeaderModel(new HeaderStyles(null, null), 'status', 'Status', false, false, null, false),       state: new GridHeaderModel(new HeaderStyles(null, null), 'state', 'State', false, false, null, false),       wave_id: new GridHeaderModel(new HeaderStyles(null, null), 'wave_id', 'Wave', false, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', false, false, null, false),       reference: new GridHeaderModel(new HeaderStyles(null, null), 'reference', 'Owner reference', false, false, null, false),       vendor_reference: new GridHeaderModel(new HeaderStyles(null, null), 'vendor_reference', 'Vendor reference', false, false, null, false),       total_items: new GridHeaderModel(new HeaderStyles(null, null), 'total_items', 'Total items', false, false, null, false),       appointment: new GridHeaderModel(new HeaderStyles(null, null), 'appointment', 'Appointment', false, false, null, false),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', false, false, null, false),       carrier: new GridHeaderModel(new HeaderStyles(null, null), 'carrier', 'Carrier', false, false, null, false),       tracking: new GridHeaderModel(new HeaderStyles(null, null), 'tracking', 'Tracking', false, false, null, false),       cartonized: new GridHeaderModel(new HeaderStyles(null, null), 'cartonized', 'Cartonized', false, false, null, false),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'created_date', 'Created on', false, false, null, false),       created_by: new GridHeaderModel(new HeaderStyles(null, null), 'created_by', 'Created by', false, false, null, false),       requested_delivery_date: new GridHeaderModel(new HeaderStyles(null, null), 'requested_delivery_date', 'Requested delivery', false, false, null, false),       cancel_threshold_date: new GridHeaderModel(new HeaderStyles(null, null), 'cancel_threshold_date', 'Cancel threshold', false, false, null, false),       shipped_date: new GridHeaderModel(new HeaderStyles(null, null), 'shipped_date', 'Shipped date', false, false, null, false),       pickup_date: new GridHeaderModel(new HeaderStyles(null, null), 'pickup_date', 'Pickup date', false, false, null, false),       ship_to: new GridHeaderModel(new HeaderStyles(null, null), 'ship_to', 'Ship to', false, false, null, false),       delivery_country: new GridHeaderModel(new HeaderStyles(null, null), 'delivery_country', 'Delivery country', false, false, null, false),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'notes', 'Notes', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_outbound_orders_gridComponentRowModel[] = [];

  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('statusIds') set $inParams_statusIds(value: any) {
    this.inParams['statusIds'] = value;
  }
  get $inParams_statusIds(): any {
    return this.inParams['statusIds'] ;
  }
  @Input('countries') set $inParams_countries(value: any) {
    this.inParams['countries'] = value;
  }
  get $inParams_countries(): any {
    return this.inParams['countries'] ;
  }
  @Input('carrierId') set $inParams_carrierId(value: any) {
    this.inParams['carrierId'] = value;
  }
  get $inParams_carrierId(): any {
    return this.inParams['carrierId'] ;
  }
  @Input('carrierServiceId') set $inParams_carrierServiceId(value: any) {
    this.inParams['carrierServiceId'] = value;
  }
  get $inParams_carrierServiceId(): any {
    return this.inParams['carrierServiceId'] ;
  }
  @Input('reference') set $inParams_reference(value: any) {
    this.inParams['reference'] = value;
  }
  get $inParams_reference(): any {
    return this.inParams['reference'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }
  @Input('waveId') set $inParams_waveId(value: any) {
    this.inParams['waveId'] = value;
  }
  get $inParams_waveId(): any {
    return this.inParams['waveId'] ;
  }

  topToolbar = {
      process: new ToolModel(new ButtonModel('process', new ButtonStyles(null, null), false, false, false, 'Process', 'icon-ic_fluent_arrow_clockwise_dashes_20_regular', null)
    , false),
      complete: new ToolModel(new ButtonModel('complete', new ButtonStyles(null, null), false, false, false, 'Complete', 'icon-ic_fluent_checkmark_circle_20_regular', null)
    , false),
      update: new ToolModel(new ButtonModel('update', new ButtonStyles(null, null), false, false, false, 'Edit', 'icon-ic_fluent_edit_20_regular', null)
    , false),
      separator3: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      manifest_print: new ToolModel(new ButtonModel('manifest_print', new ButtonStyles(null, null), false, false, false, 'Manifest', 'icon-ic_fluent_document_print_20_regular', null)
    , false),
      auto_pick: new ToolModel(new ButtonModel('auto_pick', new ButtonStyles(null, null), false, false, false, 'Auto pick', 'icon-datex-Pick', null)
    , false),
      auto_load: new ToolModel(new ButtonModel('auto_load', new ButtonStyles(null, null), false, false, false, 'Auto load', 'icon-datex-Load', null)
    , false),
      separator2: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      cancel: new ToolModel(new ButtonModel('cancel', new ButtonStyles(null, null), false, false, false, 'Cancel', 'icon-ic_fluent_dismiss_circle_20_regular', null)
    , false),
      on_delete: new ToolModel(new ButtonModel('on_delete', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      attachments: new ToolModel(new ButtonModel('attachments', new ButtonStyles(null, null), false, false, false, ' ', 'icon-ic_fluent_attach_20_regular', () => { const $utils = this.$utils; const $grid = this; return 'Attachments'; })
    , false),
      print: new ToolModel(new SplitButtonModel<{ bill_of_lading: ButtonModel, packing_list: ButtonModel }>(
        'print',
        new ButtonStyles(null, null),
        false,
        false,
        ' ',
        'icon-ic_fluent_print_20_regular',
        () => { const $utils = this.$utils; const $grid = this; return 'Print'; },
        [
          new ButtonModel('bill_of_lading', new ButtonStyles(null, null), false, false, false, 'Bill of lading', ''),
          new ButtonModel('packing_list', new ButtonStyles(null, null), false, false, false, 'Packing list', '')
        ])
    , false),
      separator4: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      refresh: new ToolModel(new ButtonModel('refresh', new ButtonStyles(null, null), false, false, false, ' ', 'icon-ic_fluent_arrow_clockwise_20_regular', () => { const $utils = this.$utils; const $grid = this; return 'Refresh'; })
    , false),
      grid_options: new ToolModel(new SplitButtonModel<{ field_selector: ButtonModel }>(
        'grid_options',
        new ButtonStyles(null, null),
        false,
        false,
        ' ',
        'icon-ic_fluent_list_20_regular',
        () => { const $utils = this.$utils; const $grid = this; return 'Grid options'; },
        [
          new ButtonModel('field_selector', new ButtonStyles(null, null), false, false, false, 'Select fields', '')
        ])
    , false)
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'From date', false, false),
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'To date', false, false),
    date_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['date_type'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Date type', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Outbound orders';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;

    (this.filters.date_type.control as SelectBoxModel).reset('CreatedSysDateTime');

    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      fromDate:  $grid.filters.date_from.control.value ,
      toDate:  $grid.filters.date_to.control.value ,
      countries:  $grid.inParams.countries ,
      carrierId:  $grid.inParams.carrierId ,
      carrierServiceId:  $grid.inParams.carrierServiceId ,
      reference:  $grid.inParams.reference ,
      take:  null ,
      skip:  null ,
      materialIds:  $grid.inParams.materialIds ,
      dateType:  $grid.filters.date_type.control.value ,
      waveId:  $grid.inParams.waveId ,
      orderIds:  null ,
      ship_to_search:  null ,
    };
    try {
      const data = await this.$datasources.SalesOrders.ds_outbound_orders_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_outbound_orders_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_outbound_orders_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_outbound_orders_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //Initialize all buttons to read only true
  $grid.topToolbar.process.control.readOnly = true;
  $grid.topToolbar.cancel.control.readOnly = true;
  $grid.topToolbar.on_delete.control.readOnly = true;
  $grid.topToolbar.complete.control.readOnly = true;
  $grid.topToolbar.update.control.readOnly = true;
  $grid.topToolbar.manifest_print.control.readOnly = true;
  $grid.topToolbar.auto_pick.control.readOnly = true;
  $grid.topToolbar.auto_load.control.readOnly = true;
  $grid.topToolbar.print.control.readOnly = true;
  $grid.topToolbar.attachments.control.readOnly = true;
  
  $event;
  
  const selectedRowsCount = $grid.selectedRows.length;
  
  // Single row only
  if (selectedRowsCount == 1) {
  
      $grid.topToolbar.attachments.control.readOnly = false;
  }
  
  // One or more rows selected
  if (selectedRowsCount > 0) {
      const selectedRows = $grid.selectedRows;
  
  
      setButtonsByOrderStatusNames($grid.selectedRows.filter(row => $utils.isDefined(row.vars.stateId)).map(row => row.vars.stateId));
  
      $grid.topToolbar.update.control.readOnly = false;
      $grid.topToolbar.manifest_print.control.readOnly = false;
      $grid.topToolbar.print.control.readOnly = false;
  }
  
  
  
  
  else {
      //await new Promise(p => setTimeout(p, 10000));
  
      $grid.topToolbar.process.control.readOnly = true;
      $grid.topToolbar.cancel.control.readOnly = true;
      $grid.topToolbar.on_delete.control.readOnly = true;
      $grid.topToolbar.complete.control.readOnly = true;
      $grid.topToolbar.update.control.readOnly = true;
      $grid.topToolbar.manifest_print.control.readOnly = true;
      $grid.topToolbar.auto_pick.control.readOnly = true;
      $grid.topToolbar.auto_load.control.readOnly = true;
  
  }
  
  
  
  /****************************************
   * FUNCTIONS
  *****************************************/
  
  async function setButtonsByOrderState(orderId: number, shipmentId: number) {
  
      let stateId: number = 1;
  
      const orders = [{
          orderId: orderId,
          shipmentId: shipmentId
      }]
  
      const order_states = (await $flows.SalesOrders.get_sales_order_state({ orders: orders })).states;
  
      if (order_states.length > 0) {
          stateId = order_states[0].stateId;
      };
  
      switch (stateId) {
          case 1: {
              $grid.topToolbar.process.control.readOnly = false;
              $grid.topToolbar.cancel.control.readOnly = false;
              $grid.topToolbar.on_delete.control.readOnly = false;
              break;
          }
          case 2: {
              $grid.topToolbar.process.control.readOnly = false;
              break;
          }
          case 3: {
              $grid.topToolbar.process.control.readOnly = false;
              break;
          }
          case 4: {
              $grid.topToolbar.process.control.readOnly = false;
              break;
          }
          case 5: {
              $grid.topToolbar.auto_pick.control.readOnly = false;
              break;
          }
          case 6: {
              $grid.topToolbar.auto_pick.control.readOnly = false;
              break;
          }
          case 7: {
              $grid.topToolbar.auto_load.control.readOnly = false;
              // Allow to complete with auto load option
              $grid.topToolbar.complete.control.readOnly = false;
              break;
          }
          case 8: {
              $grid.topToolbar.complete.control.readOnly = false;
              break;
          }
          case 9: {
              $grid.topToolbar.cancel.control.readOnly = false;
              break;
          }
      }
  }
  
  function setButtonsByOrderStatusNames(statusNames: number[]) {
  
      // TODO: Handle Manual Allocation related statuses
      if (statusNames.indexOf(1) > -1) {
          $grid.topToolbar.process.control.readOnly = false;
          $grid.topToolbar.cancel.control.readOnly = false;
          $grid.topToolbar.on_delete.control.readOnly = false;
      }
      if (statusNames.indexOf(2) > -1 || statusNames.indexOf(3) > -1 || statusNames.indexOf(4) > -1) {
          $grid.topToolbar.process.control.readOnly = false;
      }
      if (statusNames.indexOf(5) > -1 || statusNames.indexOf(6) > -1) {
          $grid.topToolbar.auto_pick.control.readOnly = false;
          $grid.topToolbar.cancel.control.readOnly = false;
      }
      if (statusNames.indexOf(7) > -1) {
          $grid.topToolbar.auto_load.control.readOnly = false;
          // Allow to complete with auto load option
          $grid.topToolbar.complete.control.readOnly = false;
      }
      if (statusNames.indexOf(8) > -1) {
          $grid.topToolbar.complete.control.readOnly = false;
      }
      if (statusNames.indexOf(9) > -1) {
          $grid.topToolbar.cancel.control.readOnly = false;
      }
  }
  }
  on_process_clicked(event = null) {
    return this.on_process_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_process_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  const isMultiShipment = selectedRows.length > 1;
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Order Process Error', 'No orders selected.');
      return;
  }
  else {
      let ordersSucceeded: { orderId: number, orderCode: string }[] = [];
      let ordersFailed: { orderId: number, orderCode: string, errorMessage: string }[] = [];
  
      /*** Prompt for processing sales order options ***/
      const dialogResult = await $shell.FootprintManager.opensales_orders_processing_options_formDialog({
          order_ids: selectedRows.map(row => row.entity.Id),
          default_waving: false
      }, 'modal');
  
      if (!dialogResult.confirm) { return; }
  
      dialogResult.waveOptions.priority = $utils.isDefined(dialogResult.waveOptions?.priority) ? dialogResult.waveOptions.priority : 1;
      dialogResult.waveOptions.description = $utils.isDefined(dialogResult.waveOptions?.description) ? dialogResult.waveOptions.description : `Created via processing flow`
      dialogResult.waveOptions.isCreateManualAllocationTasks = dialogResult.waveOptions.isCreateManualAllocationTasks ?? false
  
      /*** Validate that selected shipments are part of the same warehouse ***/
      if (dialogResult.waveOptions.groupOnWave) {
          var warehouseCheck = null;
          var firstWarehouse = null;
  
          for (const row of selectedRows) {
  
              const shipment = (await $datasources.SalesOrders.ds_get_shipments_by_shipmentId.get({
                  shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId
              })).result;
              warehouseCheck = shipment.ExpectedWarehouseId;
              if (firstWarehouse == null) {
                  firstWarehouse = warehouseCheck;
              }
              if (warehouseCheck != firstWarehouse) {
                  $shell.FootprintManager.openErrorDialog('Process Error', 'Selected orders are not part of the same warehouse, group on a single wave requested.');
                  return;
              }
          }
  
          // Create single wave
          const wave = await $flows.SalesOrders.create_single_wave_flow({
              warehouseId: warehouseCheck,
              description: dialogResult.waveOptions.description,
              priorityId: dialogResult.waveOptions.priority
          });
  
          if ($utils.isDefined(wave)) {
              var groupedWaveId = wave.waveId;
          }
          else {
              $shell.FootprintManager.openErrorDialog('Process Error', 'Error creating single wave');
              return;
          }
      }
  
      let targetState = 2 // process order
      if (dialogResult.waveOptions.isCreateWave) { targetState = 3; }
      if (dialogResult.waveOptions.isProcessWave) { targetState = 4; }
      if (dialogResult.waveOptions.isReleaseWave) { targetState = 5; }
  
      let processingStrategyWorkflowCode = dialogResult.processingStrategyWorkflowId;
  
      /*** Process orders ***/
      for (const row of selectedRows) {
          try {
              const result = await $flows.SalesOrders.is_sales_order_processable_flow({ orderId: row.entity.Id });
              if ($utils.isDefined(result.reason)) {
                  let confirm = (await $shell.FootprintManager.openConfirmationDialog(`Not all inventory is available for order '${row.entity.LookupCode}'`, 'Do you still want to attempt to process?', 'Yes', 'No'));
  
                  if (!confirm) {
                      throw new Error(result.reason);
                  }
              };
  
              let stateId: number = row.entity.OrderStatusId;
  
              const orders = [{
                  orderId: row.entity.Id,
                  orderStatusId: row.entity.OrderStatusId,
                  shipmentId: row.entity.ShipmentOrderLookups[0]?.ShipmentId,
                  expectedDate: row.entity.ShipmentOrderLookups[0]?.Shipment.ExpectedDate,
                  containerSize: row.entity.ShipmentOrderLookups[0]?.Shipment.ContainerSize,
                  shipmentStatusId: row.entity.ShipmentOrderLookups[0]?.Shipment.StatusId,
                  waveId: row.entity.ShipmentOrderLookups[0]?.Shipment.WaveId,
                  waveStatus: row.entity.ShipmentOrderLookups[0]?.Shipment.Wave?.Status.Name,
                  waveStatusId: row.entity.ShipmentOrderLookups[0]?.Shipment.Wave?.StatusId
              }]
  
              const order_states = (await $flows.SalesOrders.get_sales_order_state({ orders: orders })).states;
  
              if (order_states.length > 0) {
                  stateId = order_states[0].stateId;
              };
  
              for (let i = stateId; i < targetState; i++) {
                  switch (i) {
                      case 1: { // Process order
                          // Check if order is soft allocatable
                          const soft = await $flows.SalesOrders.is_sales_order_soft_allocatable_flow({
                              orderId: row.entity.Id
                          });
  
                          if ($utils.isDefined(soft.reason)) { /* throw new Error(soft.reason); */ }
  
                          // Process the order
                          const result = await $flows.SalesOrders.process_sales_order_flow({
                              order_id: row.entity.Id,
                              shipment_id: row.entity.ShipmentOrderLookups[0].ShipmentId,
                              processing_strategy_workflow_code: processingStrategyWorkflowCode,
                              break_child_serials: false
                          });
  
                          if ($utils.isDefined(result.reason)) { throw new Error(result.reason); }
  
                          break;
                      }
  
                      case 2: { // Create wave
                          if (dialogResult.waveOptions.groupOnWave) {
                              // Update shipment with waveId
                              await $flows.Utilities.crud_update_flow({
                                  entitySet: 'Shipments',
                                  id: row.entity.ShipmentOrderLookups[0].ShipmentId,
                                  entity: { WaveId: groupedWaveId }
                              });
  
                              break;
                          }
                          else {
                              const waveResult = await $flows.SalesOrders.create_wave_sales_order_flow({
                                  orderId: row.entity.Id,
                                  shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId
                              });
  
                              if ($utils.isDefined(waveResult.reason)) {
                                  throw new Error(waveResult.reason)
                              }
  
                              break;
                          }
  
                      }
                      case 3: { // Process wave 
                          var shipment = (await $datasources.SalesOrders.ds_get_shipments_by_shipmentId.get({
                              shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId
                          })).result;
  
                          if (dialogResult.waveOptions.groupOnWave && shipment.WaveId == groupedWaveId) {
                              // Check if candidate was already added
                              const rowFound = ordersSucceeded.find(
                                  element => element.orderId === row.entity.Id
  
                              );
  
                              break;
                          }
                          else {
                              const waveResult = await $flows.SalesOrders.process_wave_sales_order_flow({
                                  orderId: row.entity.Id,
                                  shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId,
                                  is_create_manual_allocation_tasks: dialogResult.waveOptions.isCreateManualAllocationTasks
                              });
  
                              if ($utils.isDefined(waveResult.reason)) { throw new Error(waveResult.reason); }
  
                              break;
                          }
                      }
                      case 4: { // Release wave
                          var shipment = (await $datasources.SalesOrders.ds_get_shipments_by_shipmentId.get({
                              shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId
                          })).result;
  
                          if (dialogResult.waveOptions.groupOnWave && shipment.WaveId == groupedWaveId) {
                              break;
                          }
                          else {
                              const waveResult = await $flows.SalesOrders.release_wave_sales_order_flow({
                                  orderId: row.entity.Id,
                                  shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId
                              });
  
                              if ($utils.isDefined(waveResult.reason)) { throw new Error(waveResult.reason); }
                          }
  
                          break;
                      }
                  }
              }
  
              ordersSucceeded.push({ orderId: row.entity.Id, orderCode: row.entity.LookupCode });
          }
          catch (error) {
              let targetError = error;
              while ($utils.isDefined(targetError.error)) {
                  targetError = targetError.error;
              }
  
              ordersFailed.push({
                  orderId: row.entity.Id,
                  orderCode: row.entity.LookupCode,
                  errorMessage: targetError.message
              });
          }
      }
  
      let candidates = selectedRows.filter(r => !ordersFailed.find(f => f.orderId === r.entity.Id));
  
      // If group by wave, process and release wave now
      if (dialogResult.waveOptions.groupOnWave) {
          // Abort if no candidates or if set to abort when there are errors
          if (candidates.length > 0 && (candidates.length === selectedRows.length || !dialogResult.waveOptions.abortIfErrors)) {
              const waveResult = await $flows.SalesOrders.process_single_wave_flow({
                  waveId: groupedWaveId,
                  createManualAllocationTasks: false
              });
  
              if ($utils.isDefined(waveResult.reason)) {
                  $shell.FootprintManager.openErrorDialog('Process Single Wave Error', `${waveResult.reason}`);
                  for (const candidate of candidates) {
                      ordersFailed.push({ orderId: candidate.entity.Id, orderCode: candidate.entity.LookupCode, errorMessage: waveResult.reason });
                  }
              }
              else {
                  const waveReleaseResult = await $flows.SalesOrders.release_single_wave_flow({ waveId: groupedWaveId });
                  if ($utils.isDefined(waveReleaseResult.reason)) {
                      $shell.FootprintManager.openErrorDialog('Release Single Wave Error', `${waveReleaseResult.reason}`);
                      for (const candidate of candidates) {
                          ordersFailed.push({ orderId: candidate.entity.Id, orderCode: candidate.entity.LookupCode, errorMessage: waveReleaseResult.reason });
                      }
                  }
                  else {
                      for (const candidate of candidates) {
                          ordersSucceeded.push({ orderId: candidate.entity.Id, orderCode: candidate.entity.LookupCode });
                      }
                  }
              }
          }
          else {
              for (let row of selectedRows) {
                  let isRevertable = (await $flows.SalesOrders.is_sales_order_revertable_flow({ orderId: row.entity.Id, shipmentId: row.entity.ShipmentOrderLookups[0]?.ShipmentId }));
                  if (!$utils.isDefined(isRevertable.reason)) {
                      await $flows.SalesOrders.revert_sales_order_flow({ orderId: row.entity.Id, shipmentId: row.entity.ShipmentOrderLookups[0]?.ShipmentId })
                  }
  
                  if (!ordersFailed.find(o => o.orderId === row.entity.Id)) {
                      ordersFailed.push({ orderId: row.entity.Id, orderCode: row.entity.LookupCode, errorMessage: 'Aborted because errors exist on other orders for this wave' });
                  }
              }
  
              // Cancel PickSlips
              let pickslips = (await $datasources.SalesOrders.ds_get_pickslips_by_waveId.get({ waveId: groupedWaveId })).result;
              for (let pickslip of pickslips) {
                  // Cancel if not already cancelled or completed
                  if (pickslip.StatusId !== 8 && pickslip.StatusId !== 4) {
                      await $flows.Utilities.crud_update_flow({
                          entitySet: 'PickSlips',
                          id: pickslip.Id,
                          entity: {
                              StatusId: 8
                          }
                      });
                  }
              }
  
              // Cancel wave
              await $flows.Utilities.crud_update_flow({
                  entitySet: 'Waves',
                  id: groupedWaveId,
                  entity: {
                      StatusId: 5
                  }
              });
          }
      }
  
      // all succeeded
      if (ordersSucceeded.length === selectedRows.length) {
          await $shell.FootprintManager.openInfoDialog('All order(s) processed', `Order(s) ${ordersSucceeded.map(c => c.orderCode).join(',')} processed`);
          await $grid.refresh();
      }
      // all failed
      else if (ordersFailed.length === selectedRows.length) {
          await $shell.FootprintManager.openErrorDialog('All order(s) failed to process',
              `Order(s) ${ordersFailed.map(c => c.orderCode).join(',')} could not be processed`,
              null,
              'Errors',
              ordersFailed.map(o => ({ message: `Order ${o.orderCode}`, detail: o.errorMessage })));
      }
      // Some succeeded, some failed
      else {
          await $shell.FootprintManager.openErrorDialog('Some order(s) could not be processed',
              `Order(s) ${ordersSucceeded.map(c => c.orderCode).join(',')} were processed.`,
              null,
              'Errors',
              ordersFailed.map(o => ({ message: `Order ${o.orderCode}`, detail: o.errorMessage })));
          await $grid.refresh();
      }
  }
  
  }
  on_cancel_clicked(event = null) {
    return this.on_cancel_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_cancel_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Order Cancelled Error', 'No orders selected.');
      return;
  } else {
      const candidates = [];
      const failures = [];
      const errors = [];
      for (const row of selectedRows) {
          const flowParams = {
              orderId: row.entity.Id,
              shipmentId: row.entity.ShipmentOrderLookups[0]?.ShipmentId
          };
          const result = await $flows.SalesOrders.is_sales_order_cancelable_flow(flowParams);
          const reason = result.reason;
          if ($utils.isDefined(reason)) {
              failures.push(row);
              errors.push(`Order ${row.entity.LookupCode} - ${reason}`);
          } else {
              candidates.push(row);
          }
      }
  
      // no candidate
      if (candidates.length === 0) {
          const title = 'Order Cancelled errors';
          const errorMessage = `Order(s) ${failures.map(c => c.entity.LookupCode).join(',')} cannot be cancelled`;
          const errorList = errors;
          await $shell.FootprintManager.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
          const confirmCandidates = `Order(s) ${candidates.map(c => c.entity.LookupCode).join(',')} - Once cancelled, the order cannot be restored.`
  
          let confirm = false;
          if (failures.length >= 1) {
              const title = 'Some order(s) cannot be cancelled';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message);
          } else {
              const title = 'Cancel the following order(s)';
              const message = confirmCandidates;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
              const CandidateSuccess = [];
              const CandidateFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
                      const flowParams = {
                          orderId: candidate.entity.Id
                      }
                      const result = await $flows.SalesOrders.cancel_sales_order_flow(flowParams);
                      const reason = result.reason;
                      if ($utils.isDefined(reason)) {
                          CandidateFailures.push(candidate);
                          errorMsgList.push(`Order ${candidate.entity.LookupCode} - ${reason}`);
                      } else {
                          CandidateSuccess.push(candidate);
                      }
  
                  } catch (error) {
                      CandidateFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Order ${candidate.entity.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              // all succeeded
              if (CandidateSuccess.length === candidates.length) {
                  const title = 'All order(s) cancelled';
                  const message = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} cancelled`;
                  await $shell.FootprintManager.openInfoDialog(title, message);
                  await $grid.refresh();
              } else {
                  // all failures
                  if (CandidateFailures.length === candidates.length) {
                      const title = 'All order(s) failed to cancel';
                      const message = `Order(s) ${CandidateFailures.map(c => c.entity.LookupCode).join(',')} could not be cancelled`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                  } else {
                      const title = 'Some order(s) could not be cancelled';
                      const success = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} were cancelled.`;
                      const errors = `The following order(s) could not be cancelled: ${CandidateFailures.map(c => c.entity.LookupCode).join(',')}`;
                      const message = `${success} \r\n\r\n${errors}`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
                  }
              }
          }
      }
  }
  }
  on_complete_clicked(event = null) {
    return this.on_complete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_complete_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Order Complete Error', 'No orders selected.');
      return;
  } else {
  
  
      // Extract the warehouse from the first record selected. Preventing auto picking across multiple warehouses.
      var first_warehouse_id = selectedRows[0].entity.ShipmentOrderLookups[0]?.Shipment?.ExpectedWarehouseId ?? selectedRows[0].entity.PreferredWarehouseId;
      if (!$utils.isDefined(first_warehouse_id)) {
  
          $shell.FootprintManager.openErrorDialog('Order Completion Error', 'Unable to determine the warehouse from the selected orders.');
          return;
      }
      var different = false;
  
      for (const row of selectedRows) {
  
          let warehouse_id = row.entity.ShipmentOrderLookups[0]?.Shipment?.ExpectedWarehouseId ?? row.entity.PreferredWarehouseId
          if (!$utils.isDefined(warehouse_id)) {
  
              $shell.FootprintManager.openErrorDialog('Order Completion Error', 'Unable to determine the warehouse from the selected order.');
              return;
          }
  
          if (first_warehouse_id !== warehouse_id) {
              different = true;
              break;
          }
  
  
  
      }
      if (different) {
          $shell.FootprintManager.openErrorDialog('Order Completion Error', 'Selected orders are from different warehouses, bulk completion not allowed.');
          return;
      }
  
      const dialogResult = await $shell.FootprintManager.openorder_completion_options_formDialog({ warehouseId: first_warehouse_id });
      var userConfirmed = dialogResult.confirm;
      var autoLoadConfirmed = dialogResult.autoLoad;
      var loadLocation = dialogResult.loadLocation;
  
      var autoLoad = false;
      if ($utils.isDefined(userConfirmed) && userConfirmed === true) {
  
          if ($utils.isDefined(autoLoadConfirmed) && autoLoadConfirmed === true) {
              autoLoad = true;
          }
  
      }
      else {
          return;
      }
  
  
  
      const candidates = [];
      const failures = [];
      const errors = [];
      for (const row of selectedRows) {
  
          // If auto load true attempt to auto load then validate that order is completeable
          if (autoLoad) {
              const result = await $flows.SalesOrders.auto_load_sales_order_flow({
                  orderId: row.entity.Id,
                  shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId,
                  loadLocation: loadLocation
              });
              const reason = result.reason;
  
              if ($utils.isDefined(reason)) {
                  failures.push(row);
              }
              else {
  
          
                      const flowParams = {
                          orderId: row.entity.Id
                      };
                      const result = await $flows.SalesOrders.is_sales_order_completable_flow(flowParams);
                      const reason = result.reason;
                      if ($utils.isDefined(reason)) {
                          failures.push(row);
                          errors.push(`Order ${row.entity.LookupCode} - ${reason}`);
                      } else {
                          candidates.push(row);
                      }
                  
          
  
              }
          }
          // Else check if order is completable
          else {
         
                  const flowParams = {
                      orderId: row.entity.Id
                  };
                  const result = await $flows.SalesOrders.is_sales_order_completable_flow(flowParams);
                  const reason = result.reason;
                  if ($utils.isDefined(reason)) {
                      failures.push(row);
                      errors.push(`Order ${row.entity.LookupCode} - ${reason}`);
                  } else {
                      candidates.push(row);
                  }
              
          
  
          }
      }
  
      // no candidate
      if (candidates.length === 0) {
          const title = 'Order complete errors';
          const errorMessage = `Order(s) ${failures.map(c => c.entity.LookupCode).join(',')} cannot be completed`;
          const errorList = errors;
          await $shell.FootprintManager.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
          const confirmCandidates = `Order(s) ${candidates.map(c => c.entity.LookupCode).join(',')} - Once completed, the order cannot be changed.`
  
          let confirm = false;
          if (failures.length >= 1) {
              const title = 'Some order(s) cannot be completed';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message);
          } else {
              const title = 'Complete the following order(s)';
              const message = confirmCandidates;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
              const CandidateSuccess = [];
              const CandidateFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
                      const flowParams = {
                          orderId: candidate.entity.Id
                      }
                      const result = await $flows.SalesOrders.complete_sales_order_flow(flowParams);
                      const reason = result.reason;
                      if ($utils.isDefined(reason)) {
                          CandidateFailures.push(candidate);
                          errorMsgList.push(`Order ${candidate.entity.LookupCode} - ${reason}`);
                      } else {
                          CandidateSuccess.push(candidate);
                      }
  
  
                  } catch (error) {
                      CandidateFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Order ${candidate.entity.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              // all succeeded
              if (CandidateSuccess.length === candidates.length) {
                  const title = 'All order(s) completed';
                  const message = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} completed`;
                  await $shell.FootprintManager.openInfoDialog(title, message);
                  await $grid.refresh();
              } else {
                  // all failures
                  if (CandidateFailures.length === candidates.length) {
                      const title = 'All order(s) failed to complete';
                      const message = `Order(s) ${CandidateFailures.map(c => c.entity.LookupCode).join(',')} could not be completed`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                  } else {
                      const title = 'Some order(s) could not be completed';
                      const success = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} were completed.`;
                      const errors = `The following order(s) could not be completed: ${CandidateFailures.map(c => c.entity.LookupCode).join(',')}`;
                      const message = `${success} \r\n\r\n${errors}`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
                  }
              }
          }
      }
  }
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Order Delete Error', 'No orders selected.');
      return;
  } else {
      const candidates = [];
      const failures = [];
      const errors = [];
      for (const row of selectedRows) {
          const flowParams = {
              orderId: row.entity.Id
          };
          const result = await $flows.SalesOrders.is_sales_order_deletable_flow(flowParams);
          const reason = result.reason;
          if ($utils.isDefined(reason)) {
              failures.push(row);
              errors.push(`Order ${row.entity.LookupCode} - ${reason}`);
          } else {
              candidates.push(row);
          }
      }
  
      // no candidate
      if (candidates.length === 0) {
          const title = 'Order delete errors';
          const errorMessage = `Order(s) ${failures.map(c => c.entity.LookupCode).join(',')} cannot be deleted`;
          const errorList = errors;
          await $shell.FootprintManager.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
          const confirmCandidates = `Order(s) ${candidates.map(c => c.entity.LookupCode).join(',')} - Once deleted, the order cannot be restored.`
  
          let confirm = false;
          if (failures.length >= 1) {
              const title = 'Some order(s) cannot be deleted';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message);
          } else {
              const title = 'Delete the following order(s)';
              const message = confirmCandidates;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
              const CandidateSuccess = [];
              const CandidateFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
                      const flowParams = {
                          orderId: candidate.entity.Id
                      }
                      const result = await $flows.SalesOrders.delete_sales_order_flow(flowParams);
                      const reason = result.reason;
                      if ($utils.isDefined(reason)) {
                          CandidateFailures.push(candidate);
                          errorMsgList.push(`Order ${candidate.entity.LookupCode} - ${reason}`);
                      } else {
                          CandidateSuccess.push(candidate);
                      }
                  } catch (error) {
                      CandidateFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Order ${candidate.entity.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              // all succeeded
              if (CandidateSuccess.length === candidates.length) {
                  const title = 'All order(s) deleted';
                  const message = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} deleted`;
                  await $shell.FootprintManager.openInfoDialog(title, message);
                  await $grid.refresh();
              } else {
                  // all failures
                  if (CandidateFailures.length === candidates.length) {
                      const title = 'All order(s) failed to delete';
                      const message = `Order(s) ${CandidateFailures.map(c => c.entity.LookupCode).join(',')} could not be deleted`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                  } else {
                      const title = 'Some order(s) could not be deleted';
                      const success = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} were deleted.`;
                      const errors = `The following order(s) could not be deleted: ${CandidateFailures.map(c => c.entity.LookupCode).join(',')}`;
                      const message = `${success} \r\n\r\n${errors}`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
                  }
              }
          }
      }
  }
  }
  on_update_clicked(event = null) {
    return this.on_update_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_update_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Order Update Error', 'No orders selected.');
      return;
  } else {
  
      const dialogResult = await $shell.FootprintManager.openoutbound_orders_update_formDialog({
          orders: selectedRows.map(row => ({orderId: row.entity.Id, shipmentId: row.entity.ShipmentOrderLookups[0]?.ShipmentId})) });
      const userConfirmed = dialogResult.confirm;
  
  
      if (userConfirmed) {
          
          await $grid.refresh();
      }
  
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Initialize Manifesting module
  var shippingKey = $settings.FootprintManager.EasyPostKey;
  
  if (shippingKey == 'N/A') {
  
      $grid.topToolbar.manifest_print.hidden = true;
  }
  
  
  // Check permissions 
  const p_disableProcess = $operations.FootprintManager.Disable_Outbound_Order_Processing.isAuthorized();
  const p_disableComplete = $operations.FootprintManager.Disable_Outbound_Order_Completion.isAuthorized();
  const p_disableAutoPick = $operations.FootprintManager.Disable_Outbound_Order_AutoPicking.isAuthorized();
  const p_disableAutoLoad = $operations.FootprintManager.Disable_Outbound_Order_AutoLoading.isAuthorized();
  const p_disableCancellation = $operations.FootprintManager.Disable_Outbound_Order_Cancellation.isAuthorized();
  const p_disableDeletion = $operations.FootprintManager.Disable_Outbound_Order_Deletion.isAuthorized();
  const p_disableEditing = $operations.FootprintManager.Disable_Outbound_Order_Editing.isAuthorized();
  const p_disableManifesting = $operations.FootprintManager.Disable_Outbound_Order_Manifesting.isAuthorized();
  
  const [
      disableProcess,
      disableComplete,
      disableAutoPick,
      disableAutoLoad,
      disableCancellation,
      disableDeletion,
      disableEditing,
      disableManifesting
  ] = await Promise.all([
      p_disableProcess,
      p_disableComplete,
      p_disableAutoPick,
      p_disableAutoLoad,
      p_disableCancellation,
      p_disableDeletion,
      p_disableEditing,
      p_disableManifesting
  ])
  
  $grid.topToolbar.process.hidden = disableProcess;
  $grid.topToolbar.complete.hidden = disableComplete;
  $grid.topToolbar.auto_pick.hidden = disableAutoPick;
  $grid.topToolbar.auto_load.hidden = disableAutoLoad;
  $grid.topToolbar.cancel.hidden = disableCancellation;
  $grid.topToolbar.on_delete.hidden = disableDeletion;
  $grid.topToolbar.update.hidden = disableEditing;
  $grid.topToolbar.manifest_print.hidden = disableManifesting;
  }
  on_manifest_print_clicked(event = null) {
    return this.on_manifest_print_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_manifest_print_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Manifesting Error', 'No orders selected.');
      return;
  }
  
  
  else {
  
      // Check for orders w/o shipments
      let ordersWithoutShipments = selectedRows.filter(r => r.entity.ShipmentOrderLookups == null || r.entity.ShipmentOrderLookups?.length === 0);
      if (ordersWithoutShipments.length > 0) {
          $shell.FootprintManager.openErrorDialog('Manifesting Error', `Order(s) ${ordersWithoutShipments.map(o => o.entity.LookupCode).join(", ")} do not have an associated shipment.`);
          return;
      }
  
      var shipmentIds = $grid.selectedRows.map(s => s.entity.ShipmentOrderLookups[0].ShipmentId);
      $shell.Manifesting.openmanifesting_hub({ shipmentIds: shipmentIds })
  
  
  }
  
  
  }
  on_auto_pick_clicked(event = null) {
    return this.on_auto_pick_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_auto_pick_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Order Auto Pick Error', 'No orders selected.');
      return;
  } else {
  
      // Extract the warehouse from the first record selected. Preventing auto picking across multiple warehouses.
      var first_warehouse_id = selectedRows[0].entity.ShipmentOrderLookups[0]?.Shipment?.ExpectedWarehouseId ?? selectedRows[0].entity.PreferredWarehouseId;
         if (!$utils.isDefined(first_warehouse_id)) {
  
          $shell.FootprintManager.openErrorDialog('Order Auto Pick Error', 'Unable to determine the warehouse from the selected orders.');
          return;
      }
      var different = false;
  
      for (const row of selectedRows) {
          let warehouse_id = row.entity.ShipmentOrderLookups[0]?.Shipment?.ExpectedWarehouseId ?? row.entity.PreferredWarehouseId
          if (!$utils.isDefined(warehouse_id)) {
  
              $shell.FootprintManager.openErrorDialog('Order Auto Pick Error', 'Unable to determine the warehouse from the selected order.');
              return;
          }
  
          if (first_warehouse_id !== warehouse_id) {
              different = true;
              break;
          }
          
  
      }
      if (different) {
          $shell.FootprintManager.openErrorDialog('Order Auto Pick Error', 'Selected orders are from different warehouses, auto picking not allowed.');
          return;
      }
  
      const dialogResult = await $shell.FootprintManager.openauto_pick_options_formDialog({ warehouse_id: first_warehouse_id });
      var userConfirmed = dialogResult.confirm;
      var autoLoadConfirmed = dialogResult.auto_load;
      var loadLocation = dialogResult.load_location;
      let license_plate_lookup = dialogResult.license_plate_lookup;
  
      if ($utils.isDefined(userConfirmed) && userConfirmed === false) {
  
          return;
      }
  
      const candidates = [];
      const failures = [];
      const errors = [];
      for (const row of selectedRows) {
          const flowParams = {
              orderId: row.entity.Id,
              shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId
          };
          const result = await $flows.SalesOrders.is_sales_order_pickable_flow(flowParams);
          const reason = result.reason;
          if ($utils.isDefined(reason)) {
              failures.push(row);
              errors.push(`Order ${row.entity.LookupCode} - ${reason}`);
          } else {
              candidates.push(row);
          }
      }
  
      // no candidate
      if (candidates.length === 0) {
          const title = 'Order auto pick errors';
          const errorMessage = `Order(s) ${failures.map(c => c.entity.LookupCode).join(',')} cannot be auto picked`;
          const errorList = errors;
          await $shell.FootprintManager.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
          const confirmCandidates = `Order(s) ${candidates.map(c => c.entity.LookupCode).join(',')} - Once auto picked, any changes must be coordinated through the unpicking function.`
  
          let confirm = false;
          if (failures.length >= 1) {
              const title = 'Some order(s) cannot be auto picked';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message);
          } else {
              const title = 'Auto pick the following order(s)';
              const message = confirmCandidates;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
              const CandidateSuccess = [];
              const CandidateFailures = [];
              const CandidateLoadSuccess = [];
              const CandidateLoadFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
                      const result = await $flows.SalesOrders.auto_pick_sales_order_flow({
                          orderId: candidate.entity.Id,
                          shipmentId: candidate.entity.ShipmentOrderLookups[0].ShipmentId,
                          license_plate_lookup: license_plate_lookup
                      });
                      
                      const reason = result.reason;
                      if ($utils.isDefined(reason)) {
                          CandidateFailures.push(candidate);
                          errorMsgList.push(`Order ${candidate.entity.LookupCode} - ${reason}`);
                      } else {
                          CandidateSuccess.push(candidate);
                      }
  
                      // Handle Auto Load Request
                      if ($utils.isAllDefined(userConfirmed, autoLoadConfirmed) && userConfirmed === true && autoLoadConfirmed === true) {
  
                          const flowLoadParams = {
                              orderId: candidate.entity.Id,
                              shipmentId: candidate.entity.ShipmentOrderLookups[0].ShipmentId,
                              loadLocation: loadLocation
                          }
                          const resultLoad = await $flows.SalesOrders.auto_load_sales_order_flow(flowLoadParams);
                          const reasonLoad = resultLoad.reason;
  
                          if ($utils.isDefined(reasonLoad)) {
                              CandidateLoadFailures.push(candidate);
                              errorMsgList.push(`Order ${candidate.entity.LookupCode} - ${reason}`);
                          } else {
                              CandidateLoadSuccess.push(candidate);
                          }
  
  
  
                      }
  
  
                  } catch (error) {
                      CandidateFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Order ${candidate.entity.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              // all succeeded
              if (CandidateSuccess.length === candidates.length) {
                  const title = 'All order(s) auto picked';
                  const message = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} auto picked`;
                  await $shell.FootprintManager.openInfoDialog(title, message);
                  await $grid.refresh();
              } else {
                  // all failures
                  if (CandidateFailures.length === candidates.length) {
                      const title = 'All order(s) failed to auto pick';
                      const message = `Order(s) ${CandidateFailures.map(c => c.entity.LookupCode).join(',')} could not be auto picked`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                  } else {
                      const title = 'Some order(s) could not be auto picked';
                      const success = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} were auto picked.`;
                      const errors = `The following order(s) could not be auto picked: ${CandidateFailures.map(c => c.entity.LookupCode).join(',')}`;
                      const message = `${success} \r\n\r\n${errors}`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
                  }
              }
          }
      }
  }
  }
  on_auto_load_clicked(event = null) {
    return this.on_auto_load_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_auto_load_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Order Auto Load Error', 'No orders selected.');
      return;
  } else {
      const candidates = [];
      const failures = [];
      const errors = [];
      for (const row of selectedRows) {
          const flowParams = {
              orderId: row.entity.Id,
              shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId
          };
          const result = await $flows.SalesOrders.is_sales_order_loadable_flow(flowParams);
          const reason = result.reason;
          if ($utils.isDefined(reason)) {
              failures.push(row);
              errors.push(`Order ${row.entity.LookupCode} - ${reason}`);
          } else {
              candidates.push(row);
          }
      }
  
      // no candidate
      if (candidates.length === 0) {
          const title = 'Order auto load errors';
          const errorMessage = `Order(s) ${failures.map(c => c.entity.LookupCode).join(',')} cannot be auto loaded`;
          const errorList = errors;
          await $shell.FootprintManager.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
          const confirmCandidates = `Order(s) ${candidates.map(c => c.entity.LookupCode).join(',')} - Once auto loaded, any changes must be coordinated through the unpicking function.`
  
          let confirm = false;
          if (failures.length >= 1) {
              const title = 'Some order(s) cannot be auto loaded';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message);
          } else {
              const title = 'Auto load the following order(s)';
              const message = confirmCandidates;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
              const CandidateSuccess = [];
              const CandidateFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
                      const flowParams = {
                          orderId: candidate.entity.Id,
                          shipmentId: candidate.entity.ShipmentOrderLookups[0].ShipmentId
                      }
                      const result = await $flows.SalesOrders.auto_load_sales_order_flow(flowParams);
                      const reason = result.reason;
                      if ($utils.isDefined(reason)) {
                          CandidateFailures.push(candidate);
                          errorMsgList.push(`Order ${candidate.entity.LookupCode} - ${reason}`);
                      } else {
                          CandidateSuccess.push(candidate);
                      }
  
                     
                  } catch (error) {
                      CandidateFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Order ${candidate.entity.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              // all succeeded
              if (CandidateSuccess.length === candidates.length) {
                  const title = 'All order(s) auto loaded';
                  const message = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} auto loaded`;
                  await $shell.FootprintManager.openInfoDialog(title, message);
                  await $grid.refresh();
              } else {
                  // all failures
                  if (CandidateFailures.length === candidates.length) {
                      const title = 'All order(s) failed to auto load';
                      const message = `Order(s) ${CandidateFailures.map(c => c.entity.LookupCode).join(',')} could not be auto loaded`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                  } else {
                      const title = 'Some order(s) could not be auto loaded';
                      const success = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} were auto loaded.`;
                      const errors = `The following order(s) could not be auto loaded: ${CandidateFailures.map(c => c.entity.LookupCode).join(',')}`;
                      const message = `${success} \r\n\r\n${errors}`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
                  }
              }
          }
      }
  }
  }
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const exportLimit = $settings.FootprintManager.ExcelExportLimit
  
  let exportAsDetails = await $shell.FootprintManager.openConfirmationDialog('Choose Export', 'Export Details or Summary?', 'Details', 'Summary');
  if (!$utils.isDefined(exportAsDetails)) { return; }
  
  //Initialize
  var wb = $event;
  var transactions = [];
  var totalRecords: number;
  
  var exportType: string = "Summary";
  if (exportAsDetails) {
      exportType = "Details"
  }
  
  let dateFormat = $settings.FootprintManager.DateFormat ?? "MM/dd/yyyy";
  
  // Get Selected Rows only. 
  if ($grid.selectedRows.length > 0) {
      var orderIds = [...new Set($grid.selectedRows.map(o => o.entity.Id))]
      totalRecords = $grid.selectedRows.length;
  }
  
  let inParams = {
      ownerId: $grid.inParams.ownerId,
      projectId: $grid.inParams.projectId,
      warehouseIds: $grid.inParams.warehouseId,
      statusIds: $grid.inParams.statusIds,
      fromDate: $grid.filters.date_from.control.value,
      toDate: $grid.filters.date_to.control.value,
      dateType: $grid.filters.date_type.control.value,
      countries: $grid.inParams.countries,
      carrierId: $grid.inParams.carrierId,
      carrierServiceTypeId: $grid.inParams.carrierServiceId,
      materialIds: $grid.inParams.materialIds,
      fullTextSearch: $grid.fullTextSearch,
      orderIds: orderIds,
      exportLimit: exportLimit,
      reference: $grid.inParams.reference,
      totalRecords: totalRecords,
      exportType: exportType,
      dateFormat: dateFormat,
      waveId: $grid.inParams.waveId
  }
  
  let export_results = (await $flows.SalesOrders.excel_export_flow(inParams))
  
  if ($utils.isDefined(export_results.transactions)) {
  
      transactions = export_results.transactions;
  
      if ($utils.isDefined(export_results.logMessage)) {
          if (export_results.logMessage.length >= 2) {
              await $shell.FootprintManager.openInfoDialog(export_results.logMessage[0], export_results.logMessage[1]);
          }
      }
  
      var ws = $utils.excel.json_to_sheet(transactions);
      $utils.excel.book_append_sheet(wb, ws, "OutboundOrdersExport");
  
  } else {
      throw new Error("Did not obtain transactions to export from the excel_export_flow!")
  }
  }
  on_bill_of_lading_clicked(event = null) {
    return this.on_bill_of_lading_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_bill_of_lading_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  const selectedRows = $grid.selectedRows;
  
  
  
  for (let selectedRow of selectedRows) {
      let orderId = selectedRow.entity.Id;
      await $shell.SalesOrders.openoutbound_bill_of_lading_reportDialog({ orderId: orderId });
  }
  }
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 03/18/2024
  
  const order_data = $grid.rows;
  const outbound_orders = $grid.rows.map(row => row.entity.Id);
  const outbound_shipments = $grid.rows.map(row => row.entity.ShipmentOrderLookups[0]?.ShipmentId)
  
  if (outbound_orders.length > 0) {
  
      const orders = order_data.map(o => {
          return {
              orderId: o.entity.Id,
              orderStatusId: o.entity.OrderStatusId,
              orderStatus: o.entity.Status.Name,
              requestedDeliveryDate: o.entity.RequestedDeliveryDate,
              shipmentId: o.entity.ShipmentOrderLookups[0]?.ShipmentId,
              expectedDate: o.entity.ShipmentOrderLookups[0]?.Shipment.ExpectedDate,
              containerSize: o.entity.ShipmentOrderLookups[0]?.Shipment.ContainerSize,
              shipmentStatusId: o.entity.ShipmentOrderLookups[0]?.Shipment.StatusId,
              waveId: o.entity.ShipmentOrderLookups[0]?.Shipment.WaveId,
              waveStatus: o.entity.ShipmentOrderLookups[0]?.Shipment.Wave?.Status.Name,
              waveStatusId: o.entity.ShipmentOrderLookups[0]?.Shipment.Wave?.StatusId
          }
      });
  
      const p_order_states = $flows.SalesOrders.get_sales_order_state({ orders: orders });
  
      const p_dock_appointments = $datasources.DockAppointments.ds_get_dock_appointment_by_orderIds.get({ orderIds: outbound_orders });
      const p_order_addresses = $flows.Addresses.get_addresses_single_string_by_orderIds({ orderIds: outbound_orders });
  
      const [{ states: order_states }, { result: dock_appointments }, order_addresses] = await Promise.all([p_order_states, p_dock_appointments, p_order_addresses]);
  
      const formatted_dock_appointments: { id: number; formatted_value: string }[] = (await $flows.DockAppointments.get_formatted_dock_appointment({
          dock_appointments: dock_appointments.map(a => {
              let scheduled_arrival = a.convertedScheduledArrival?.convertedDate;
              let scheduled_location = $utils.isDefinedTrimmed(a.DockAppointment?.ScheduledLocation?.ShortName)
                  ? a.DockAppointment?.ScheduledLocation?.ShortName
                  : a.DockAppointment?.ScheduledLocation?.Name;
              let assigned_location = $utils.isDefinedTrimmed(a.DockAppointment?.AssignedLocation?.ShortName)
                  ? a.DockAppointment?.AssignedLocation?.ShortName
                  : a.DockAppointment?.AssignedLocation?.Name;
              let dock_door = $utils.isDefinedTrimmed(assigned_location)
                  ? assigned_location
                  : ($utils.isDefinedTrimmed(scheduled_location) ? scheduled_location : 'Unassigned');
  
              return {
                  id: a.DockAppointmentId,
                  optimal_inputs: {
                      scheduled_location_name: dock_door,
                      assigned_location_name: dock_door,
                      status_id: a?.DockAppointment?.StatusId,
                      lookup: a.DockAppointment?.LookupCode,
                      scheduled_arrival: scheduled_arrival
                  }
              };
          })
      })).dock_appointments;
  
  
      const address_array = order_addresses.Addresses.map(row => row.OrderId);
      const state_array = order_states.map(row => row.orderId);
  
      for (let row of order_data) {
  
          let picked_total = 0;
          let expected_total = 0;
  
          let orderIndex = -1;
          let orderId = row.entity.Id;
          let orderStatusId = row.entity.OrderStatusId;
  
          let stateId: number = orderStatusId;
          let stateName: string = row.entity.Status.Name;
  
          orderIndex = state_array.indexOf(orderId)
          if (orderIndex > -1) {
              picked_total = order_states[orderIndex].picked_total;
              expected_total = order_states[orderIndex].expected_total;
              stateId = order_states[orderIndex].stateId;
              stateName = order_states[orderIndex].stateName;
          };
  
          //Set the total items
          if (expected_total > 0) {
              if (orderStatusId === 1 && expected_total > 0) {
                  row.cells.total_items.displayControl.text = `${expected_total}`
              } else {
                  row.cells.total_items.displayControl.text = `${picked_total} of ${expected_total}`
              };
          };
  
          row.vars.stateId = stateId;
          row.cells.state.displayControl.text = stateName;
  
          // Apply ship to
          orderIndex = address_array.indexOf(orderId)
          if (orderIndex >= 0) {
  
              let address = order_addresses.Addresses[orderIndex]
  
              if ($utils.isDefined(address)) {
  
                  let deliveryAddressCountry = '';
                  let shipTo = '';
  
                  shipTo = address.Address;
  
                  if ($utils.isDefined(address.Country)) {
                      deliveryAddressCountry = address.Country;
                  };
  
                  if ($utils.isDefined(shipTo)) {
                      if (!shipTo.includes('ord-')) {
                          row.cells.ship_to.displayControl.text = shipTo
                          row.cells.delivery_country.displayControl.text = deliveryAddressCountry
                      }
                      else {
                          row.cells.ship_to.displayControl.text = '';
                          row.cells.delivery_country.displayControl.text = '';
                      };
                  };
              };
          };
  
          // Apply appointment text logic
          const dockAppointmentId = dock_appointments.find(a => a.ItemEntityId === row.entity.Id)?.DockAppointmentId;
          if (dockAppointmentId) {
              row.vars.dockAppointmentId = dockAppointmentId;
              row.cells.appointment.displayControl.text = formatted_dock_appointments.find(a => dockAppointmentId === a.id)?.formatted_value;
          }
          else {
              row.cells.appointment.displayControl.text = '  +'
          };
      };
  };
  if ($utils.isDefined($grid.inParams.waveId)) {
      $grid.headers.wave_id.hidden = true;
  };
  }
  on_field_selector_clicked(event = null) {
    return this.on_field_selector_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_field_selector_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let columns: { Key: string, Name: string, IsSelected: boolean }[] = [];
  
  for (let key in $grid.headers) {
      columns.push({ Key: key, Name: $grid.headers[key].name, IsSelected: !$grid.headers[key].hidden });
  }
  
  let result = (await $shell.FootprintManager.openfield_selector_gridDialog({ Columns: columns }));
  
  if ($utils.isDefined(result.Columns)) {
      for (let key in $grid.headers) {
          $grid.headers[key].hidden = !result.Columns.find(column => column.Key === key)?.IsSelected
      }
  }
  }
  on_attachments_clicked(event = null) {
    return this.on_attachments_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_attachments_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.selectedRows.length === 1) {
      await $shell.FootprintManager.openorders_attachments_hubDialog({ 
          orderId: $grid.selectedRows[0].entity.Id, shipmentId: $grid.selectedRows[0].entity.ShipmentOrderLookups[0].ShipmentId},'flyout',EModalSize.Large);
  }
   
  }
  on_refresh(event = null) {
    return this.on_refreshInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_refreshInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $grid.refresh();
  }
  on_packing_list_clicked(event = null) {
    return this.on_packing_list_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_packing_list_clickedInternal(
    $grid: FootprintManager_outbound_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_outbound_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  const selectedRows = $grid.selectedRows;
  
  
  
  for (let selectedRow of selectedRows) {
      let orderId = selectedRow.entity.Id;
      await $shell.SalesOrders.openpacking_list_reportDialog({ orderId: orderId });
  }
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'FootprintManager_outbound_orders_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
